import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageLayoutService {

	constructor() { }

	setLayoutStyle(layout:string) {
		let htmlTag = document.getElementsByTagName('html')[0];
		let classList = htmlTag.classList;

		this.clearLayoutStyle();

		classList.add(layout);
	}

	clearLayoutStyle() {
		let htmlTag = document.getElementsByTagName('html')[0];
		let classList = htmlTag.classList;

		// remove all classes from html tag
		for (var i = 0; i < classList.length; i++){
			classList.remove(classList[i]);
		}
	}
}